<template>
<div>
    <form :action="routeData" method="POST" v-if="month">
        <div class="row" v-if="month">

            <div class="col-lg-3 col-md-6 col-sm-7 col-12">
                <input type="hidden" name="_token" :value="csrf">
                {{ month  ?  'Mes' :'Desde'}}
                <date-picker format="MM-YYYY" type="month" v-if="month" v-model="date_start" :disabled-date="disabledDates" />
                <!-- <Datepicker v-model="date_start" input-class="input-datepicker" :language="es" /> -->

            </div>
            <div class="col-lg-3 col-md-6 col-sm-7 col-12">
                <div class="form-group">
                    <label>
                        <select class="custom-select custom-select-sm" v-model="type" style="width:200px; height:35px" name="type">
                            <option value="1">Buscar</option>
                            <option value="2">Actualizar</option>
                        </select>
                    </label>

                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 ">
                <button class="btn btn-primary" type="submit">Generar</button>
            </div>
        </div>
    </form>

    <div class="row" v-if="!month">
        <div class="col-lg-3 col-md-6 col-sm-7 col-12">
            Desde
            <b-form-datepicker id="fechaInicioGrafico" v-model="date_start" placeholder="Fecha de inicio" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
            <!-- <Datepicker v-model="date_start" input-class="input-datepicker" :language="es" /> -->

        </div>
        <div class="col-lg-3 col-md-6 col-sm-7 col-12">
            Hasta
            <b-form-datepicker id="fechaFinalGrafico" v-model="date_end" placeholder="Fecha de inicio" v-bind="datepicker.etiquetas[datepicker.idioma] || {}" :locale="datepicker.idioma" class="mb-2"></b-form-datepicker>
            <!-- <Datepicker v-model="date_end" input-class="input-datepicker" :language="es" /> -->
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 ">
            <button class="btn btn-primary" @click="search">Buscar</button>
        </div>
    </div>
</div>
</template>

<script>
var moment = require('moment');

import { labels, locale } from "../datepicker-intl.json";

// import Datepicker from 'vuejs-datepicker';
// import { en, es } from /'vuejs-datepicker/dist/locale'
export default {
    props: ['month', 'routeData','fecha'],
    components: {
        // Datepicker
    },
    data() {
        return {
            // es: es,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            date_start: this.set_start(),
            date_end: new Date(),
            datepicker: {
                etiquetas: labels,
                idioma: locale,
            },
            type:1
        }
    },
    mounted() {
        // this.search();
        if (!this.month)
            this.$emit('search', { date_start: this.date_start, date_end: this.date_end })

        console.log(this.fecha);
        if(this.fecha)
            this.date_start = new Date(this.fecha)
    },
    computed: {
        // date_start: {
        //     get() {
        //         if (this.month) {
        //             let current = this.getCurrentMonth();
        //             return new Date((current.year + 1900) + "/" + current.month + "/01")
        //         } else {
        //             return new Date()
        //         }
        //     },
        //     set(val) {
        //         this.date_start = val;
        //     }
        // }
    },
    methods: {
        set_start() {
            if (this.month) {
                let current = this.getCurrentMonth();
                return new Date((current.year + 1900) + "/" + current.month + "/01")
            } else {
                return new Date()
            }
        },
        getCurrentMonth() {
            let month = new Date().getMonth();
            let year = new Date().getYear();
            if (month == 0) {
                month = 12
                year = year - 1
            }
            return { month: month, year: year }
        },
        disabledDates(date) {
            // console.log("date", date);
            let current = this.getCurrentMonth();
            return date >= new Date((current.year + 1900) + "/" + (current.month + 1) + "/01");
        },
        search() {
            this.$emit('search', { date_start: this.date_start, date_end: this.date_end })
        }
    },
    watch: {
        date_end() {
            // console.log();
            // console.log();

            let end = new Date(this.date_end).getTime();
            let start = new Date(this.date_start).getTime()
            if (end > start) {
                // this.$swal({ type: 'error', title: 'Error', text: 'Las fechas no corresponden' })
                alert("Las fechas no corresponden");
            }
        }
    }
}
</script>

<style>
.input-datepicker {
    width: 100%;
}
</style>
